import * as types from './activities.types';
export const activitiesPageSelectors: types.IActivityPageSelectors = {
  selectActivities: (state) => state.page.activities.activitiesIds,
};
